export default __webpack_public_path__ + "static/media/derivativeanalyticsvideo.23f00f96.mp4";